<template>
    <div>
        <div class="bg-white mt-12 ml-20 text-dark">
            <p class="inline-block font-weight-bolder" style="margin-left: 10px">Add project contact to address book?</p>
            <span class="pull-right">
                        <label for="customButtonSwitch" class="inline-block">OFF</label>
                        <b-form-checkbox @change="contactSwitchUpdate" name="custom-button" v-model="addContactToAddressBook" id="customButtonSwitch" class="inline-block" style="margin-left:10px !important" switch>
                        </b-form-checkbox>
                        <label for="customButtonSwitch" class="inline-block">ON</label>
                        </span>
        </div>
    </div>
</template>

<script>

import Form from "../../../utils/form";

export default {
    name: 'contact-to-address-book',
    props: {
        team:{},
        user:{}
    },
    data() {
        return {
            'addContactToAddressBook':(this.team.add_contact_to_address_book === 1),
        };
    },
    created() {

    },
    methods: {
        contactSwitchUpdate(){
            this.$nextTick(()=>{
                let data = {
                    'access': (this.addContactToAddressBook)? 1:0
                };
                axios.post(route('contact-to-address-book.update'), data).then(
                    (response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        })
                    }
                );
            });
        },
    },


}
</script>

